import cloudServiceModule from '../cloudService.module';

class AcsApiService {
    constructor(__env, $http, $q, authenticationService) {
        this.__env = __env;
        this.$http = $http;
        this.$q = $q;
        this.authenticationService = authenticationService;
    }

    createCloudRegistration(instanceGuid) {
        const deferred = this.$q.defer();

        this.authenticationService.getToken().then(cloudToken => {
            this.$http
                .post(
                    `${this.__env.cloudApiUrl}/api/v2/acs/registration`,
                    { instanceGuid: instanceGuid },
                    { headers: { token: cloudToken } }
                )
                .then(
                    response => deferred.resolve(response.data),
                    deferred.reject
                );
        }, deferred.reject);

        return deferred.promise;
    }
}

export default cloudServiceModule.service('acsApiService', AcsApiService);



// WEBPACK FOOTER //
// ./modules/cloudService/accessControl/acsApiService.service.js